import script from "./Headline.vue?vue&type=script&setup=true&lang=js"
export * from "./Headline.vue?vue&type=script&setup=true&lang=js"

import "./Headline.vue?vue&type=style&index=0&id=cdbba78e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdbba78e"]])

export default __exports__